<template>
    <p class="posi-relative input-container flex">
        <!--基础的input-->
        <input :type="typeOver" :id='id' :value='value' :class="classCpt" :style="styleCpt" 
            :maxlength="maxlength" :placeholder="placeholder" :autofocus="autofocus" 
            :readonly="readonly===''" @click="$emit('click')" ref="inputHandle"  
            v-on="inputListeners" :onmousewheel="mouseeheel" @mousewheel.prevent="stopScrollFun" v-thousandth/>
        <img v-if="isClear&&readonly!==''" @click="clearInput" src="../../assets/img/kcsc.png" class="posi-absolute">
     </p>
</template>

<script>
	export default{
		inheritAttrs: false, //根元素不继承特性
		mounted(){
            //-- 如果设定了数据框的 类型
			if(this.type){ 
				this.typeOver = this.type;
			}
			//-- 如果设定了样式
			if(this.styleCpt){ 
				this.styleOver = this.styleCpt;
			}
			//如果有初始值
			if(this.initVal){
				this.value = this.initVal;
            }
			//-- type 为 number 时，禁止鼠标事件
			/* if(this.onmousewheel === '' && this.onmousewheel != undefined){
				this.mouseeheel = 'return false;';
			} */
		},
        props:['type','id','styleCpt','classCpt','placeholder','initVal',
               'autofocus','readonly','maxlength','onmousewheel'],
		data(){
			return{
				typeOver:'text', //-- 默认输入框为 文本框
				value:'',
				styleOver:'', //-- 样式
				mouseeheel:'', //-- 禁止滑轮滚动
				isFocus:false, //-- 是否获得焦点
				isClear:false, //-- 是否显示删除
			}
		},
		computed:{
			inputListeners:function(){
				let vm = this;
				//Object.assign 将所有的对象合并为一个新对象
				return Object.assign(
					{},
					// 我们从父级添加所有的监听器
					this.$listeners,
					//然后我们添加定义监听器，或覆写一些监听器行为
					{
						// 这里确保组件配合 `v-model` 的工作
				        input: (event) => {
							vm.$emit('input', event.target.value)
							vm.value = event.target.value;
				        },
				        //获得焦点事件
				        onfocus: () => { vm.$emit('onfocus') },
				        //失去焦点事件
				        onblur: () => { vm.$emit('onblur') },
					}
				)
			}
		},
		watch:{
			value(newVal,oldVal){			 
				if(this.typeOver == 'text'){ //-- 如果输入了表情
					newVal = this.$tools.noEmoji(newVal);
				}else if(this.type == 'tel'){ //-- 如果是手机号
					if(newVal != '' && newVal.substr(0,1) != 1){
						this.value = oldVal;
					}else if(newVal.length > 11 || (!this.$tools.isNumber(newVal) && newVal != '')){
						this.value = newVal.substr(0,11);
					}
				}
                else if(this.type == 'number' || this.type == 'money'){ //-- 如果是数字类型
					//-- 校验输入的是不是数字
					if(!this.$tools.isNumber(newVal) && newVal != ''){
						this.value = oldVal; 	
					}else if(newVal.indexOf('.') > -1 && newVal.split('.')[1].length > 2){
						this.value = oldVal; //-- 只能保持小数点 两位
					}else if(newVal.length > this.maxlength){
						this.value = oldVal;  //-- 不能超过最大限制位数
					}else if(this.type == 'money' && newVal > 2000000000){
						this.value = oldVal;  //-- 如果是货币，则不能超过20亿
					}else if(this.type == 'money' && newVal.length >= 2 && newVal.substr(0,2) == '00' ){
						this.value = oldVal;  
					}else if(this.type == 'money' && newVal.length >= 4 && newVal.substr(0,4) == '0.00' ){
						this.value = oldVal;  
					}
				}else if(this.type == 'identityNo'){
					if(!this.$tools.isNumber(newVal) && newVal != ''&&newVal.length<=17){
						this.value = oldVal;
					}else if(newVal.length == 18){
							let reg = /^[0-9]*$/
							if(!reg.test(newVal.charAt(newVal.length-1)) && newVal.charAt(newVal.length-1)!='x' && newVal.charAt(newVal.length-1)!='X'){
								this.value = oldVal;
							}
						}
				}else if(this.type == 'numbers'){
          this.value=this.value.replace(/\D/g,'')
        }
				if(newVal.length > 0){
					this.isClear = true;
				}else{
					this.isClear = false;
        }
            
				this.$emit('input', this.value)
			}
		},
		methods: {
			//-- 一键清除 input 的值
			clearInput(){
				this.value = ''; 
				//-- 清除后 并 获得焦点
				this.$refs.inputHandle.focus()
			},
			//-- 禁止滚轮滚动事件（结合type="number"使用）
			stopScrollFun(evt) {   
				return false;  
			},
			setValue(val){
				this.value = val;
			},
			getValue(){
				return this.value;
            },
            format (num) {
                return (num+ '').replace(/(\d{1,3})(?=(\d{3})+(?:$|\.))/g,'$1,');
            }
		},
	}
</script>

<style scoped lang="less">
	.input-container{
		input{
			flex: 1 ;
		}
		img{
			height: .8rem;
			width: .8rem;
			right: .5rem;
			top: .7rem;
			cursor: pointer;
		}	
		img:hover{
			height: .9rem;
			width: .9rem;
			top: .65rem;
		}
	}
	
</style>


// WEBPACK FOOTER //
// src/components/BaseCpts/inputBase.vue